import { render, staticRenderFns } from "./InventoryProducts.vue?vue&type=template&id=e2dcc1a4&scoped=true&"
import script from "./InventoryProducts.vue?vue&type=script&lang=ts&"
export * from "./InventoryProducts.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InventoryProducts.vue?vue&type=style&index=1&id=e2dcc1a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2dcc1a4",
  null
  
)

export default component.exports